module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG89def777d99a3bb366c5d59c29791444_clip.016595c3.png";